import {Component, OnInit, ViewChild} from '@angular/core';
import {Chat} from "../../../../models/chat.model";
import {FormBuilder, FormControl} from "@angular/forms";
import {NotificationService} from "../../../../services/notification.service";
import {ChatService} from "../../../../services/chat.service";
import Swal from "sweetalert2";
import {Notification} from "../../../../models/notification.model";


@Component({
  selector: 'app-chat-notification',
  templateUrl: './chat-notification.component.html',
  styleUrls: ['./chat-notification.component.scss']
})
export class ChatNotificationComponent implements OnInit {

  chatNotifications: Notification[] = [];
  @ViewChild('closebutton') closebutton;

// @ts-ignore
  currentChat: Chat = [];
  get f() { return this.chatForm.controls; }
  chatForm = this.fb.group({
    type: new FormControl('', []),
    message: new FormControl('', []),
    sender: new FormControl('', []),
    receiver: new FormControl('', []),
  });


  /*
-----------------------------         for all page attribute    --------------------------------
*/
  search: any;
  page = 1;
  perPage = 10;

  /*
  end for all page
   */
  /*
  -------------------------------------------------------------------------
   */

  constructor(private fb: FormBuilder, private notificationService: NotificationService, private chatService: ChatService) { }

  ngOnInit(): void {
    this.loadChatNotification();
  }

  onReply(c: any) {
    //console.log(c);
    this.chatService.getChatById(c.objectId).subscribe(rs => {
      this.currentChat = rs;
      //console.log(rs)
    });
  }

  onChatFormSubmit() {
    const chat: Chat = this.currentChat;
    chat.replied = true;
    chat.type = 'admin';
    chat.message = this.chatForm.controls['message'].value;
    chat.receiver = this.currentChat.sender;
    this.chatService.saveChat(chat).subscribe(rs => {
      //console.log(rs);
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Message a été envoyé avec succès"',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadChatNotification();
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez verifier les données',
        showConfirmButton: false,
        timer: 2500
      });
    });
  }

  loadChatNotification() {
    this.notificationService.getChatNotification().subscribe(rs => {
      this.chatNotifications = rs;
      //console.log("-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-")
      //console.log(rs)
    });
  }
  markNotificationAsRead(id: any) {
    this.notificationService.markNotificationAsRead(id).subscribe(rs => {
      this.loadChatNotification();
    });
  }
  /*
  -----------------------------          for all page methodes      -----------------------------
   */

  onTableDataChange(event: any) {
    this.page = event;
    this.loadChatNotification();
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
    //console.log(this.perPage);
  }
  close() {
    this.closebutton.nativeElement.click();
  }

}
